var getVisibleColor = function (primaryColor) {
    if (primaryColor === null) {
        return primaryColor;
    }
    var hex = primaryColor;
    if (primaryColor.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var red = parseInt(hex.slice(0, 2), 16) * 0.299;
    var green = parseInt(hex.slice(2, 4), 16) * 0.587;
    var blue = parseInt(hex.slice(4, 6), 16) * 0.114;
    var l = red + green + blue;
    return l > 186 ? '#000000' : primaryColor;
};
export default getVisibleColor;
//# sourceMappingURL=getVisibleColor.js.map